import React from "react"
import { Text } from "~components/El"

interface NameProps {
  name: string
}

const Name: React.FC<NameProps> = ({ name }) => {
  return (
    <Text fontSize="xl" color="#000" opacity={0.8} maxWidth="180px">
      {name}
    </Text>
  )
}

export default Name
